// EmptyCategory.tsx - Modern modal for handling empty category options
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import './EmptyCategory.scss';
import { MenuCategoryNode } from '../../../../../../types/menu.types';

interface EmptyCategoryProps {
  show: boolean;
  handleClose: () => void;
  category: MenuCategoryNode | null;
  onSelectAddItems: () => void;
  onSelectAddSubcategory: () => void;
}

/* ======================= EmptyCategory Modal ======================= */

const EmptyCategory: React.FC<EmptyCategoryProps> = ({
  show,
  handleClose,
  category,
  onSelectAddItems,
  onSelectAddSubcategory,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered className="empty-category-modal">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Categoría Vacía</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="intro-text">
          <p>
            La categoría <strong>{category?.name}</strong> está vacía. Las categorías pueden contener{' '}
            <em>items</em> o <em>subcategorías</em>, pero <strong>NO AMBOS</strong>.
          </p>
        </div>

        <p className="options-title">
          Por favor, elige una opción para continuar:
        </p>

        <div className="category-options-container">
          <div onClick={onSelectAddItems} className="category-option">
            <span className="option-title">Agregar Items</span>
            <p className="option-description">
              Tu categoría contendrá productos individuales que los clientes pueden ordenar directamente.
              Se abrirá automáticamente el formulario para crear el primer producto.
            </p>
            <div className="option-examples">
              <div className="examples-title">Ejemplo:</div>
              Si tu categoría es <strong>Bebidas</strong>, agregarías items como:
              <strong> Coca Cola</strong>, <strong> Sprite</strong>, <strong> Agua</strong>, etc.
            </div>
          </div>

          <div onClick={onSelectAddSubcategory} className="category-option">
            <span className="option-title">Agregar Subcategorías</span>
            <p className="option-description">
              Tu categoría se convertirá en una categoría padre que organiza otras categorías más específicas.
            </p>
            <div className="option-examples">
              <div className="examples-title">Ejemplo:</div>
              Si tu categoría es <strong>Platos Principales</strong>, podrías tener subcategorías como:
              <strong> Carnes</strong>, <strong> Pescados</strong>, <strong> Vegetariano</strong>, etc.
            </div>
          </div>
        </div>

        <div className="important-note">
          <span className="note-icon">⚠️</span>
          <strong>Importante:</strong> Una vez que elijas una opción, no podrás cambiar el tipo de contenido de esta categoría.
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="none" onClick={handleClose} className="form-button-cancel">
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmptyCategory;

